<div class="CloseModel" (click)="closeDialog()"><span><img src="assets/images/close.svg"  alt="close" /></span></div>
<div class="popup w-100">
<h3>{{title}}</h3>
<p class="text-danger">{{msg}}</p>
  <form class="blue_rectangle" [formGroup]='forgotPassword'>
    <div class="row m-0 w-100">
      <div class="email">
        <mat-form-field class="w-100">
          <input type="email" matInput placeholder="Email Address" formControlName="user_email" required>
          <mat-error *ngIf='forgotPassword.get("user_email").touched && !forgotPassword.get("user_email").valid'>Enter a valid email</mat-error>
        
        </mat-form-field>
      </div>
      <div class="px-2 ">
        <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)"
          [useGlobalDomain]="false" formControlName="recaptcha">
        </ngx-recaptcha2>
      </div>
    
      <div class="buttonpadding w-100">
        <button mat-raised-button color="primaryCus" (click)="sendResetLink();" [disabled]="!this.forgotPassword.valid" class="btn_padding">Submit</button>
      </div>
      
   
    </div>
  </form>
</div>